(() => {
  if (window.okBoostCardDetails) return;
  const cache = new Map(), pending = new Map(), queue = new Set(), failed = new Map();
  let queued = false;
  async function request(batch) {
    let remaining = batch;
    for (let attempt = 0; attempt < 3 && remaining.length; attempt++) {
      if (attempt) await new Promise(resolve => setTimeout(resolve, attempt * 750));
      const controller = new AbortController();
      const timeout = setTimeout(() => controller.abort(), 8000);
      try {
        const url = new URL((window.Shopify?.routes?.root || '/') + 'search', location.origin);
        url.searchParams.set('view', 'boost-card-details');
        url.searchParams.set('q', remaining.join('|'));
        const response = await fetch(url, {credentials: 'same-origin', signal: controller.signal});
        if (!response.ok) throw new Error('Card details unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        doc.querySelectorAll('template[data-ok-card]').forEach(template => {
          const handle = template.dataset.okCard;
          if (!remaining.includes(handle)) return;
          cache.set(handle, template.outerHTML);
          pending.get(handle)?.resolve(template.outerHTML);
          pending.delete(handle);
          failed.delete(handle);
        });
        remaining = remaining.filter(handle => !cache.has(handle));
      } catch {} finally {
        clearTimeout(timeout);
      }
    }
    remaining.forEach(handle => {
      failed.set(handle, Date.now());
      pending.get(handle)?.reject(new Error('Missing card details'));
      pending.delete(handle);
    });
  }
  function flush() {
    queued = false;
    const handles = [...queue]; queue.clear();
    const firstRow = window.matchMedia('(max-width: 767px)').matches ? 2 : 6;
    for (let i = 0; i < handles.length;) {
      const size = i === 0 ? firstRow : 20;
      request(handles.slice(i, i + size));
      i += size;
    }
  }
  window.okBoostCardDetails = handles => Promise.allSettled(handles.map(handle => {
    if (cache.has(handle)) return Promise.resolve(cache.get(handle));
    if (pending.has(handle)) return pending.get(handle).promise;
    if (failed.has(handle) && Date.now() - failed.get(handle) < 30000) return Promise.reject(new Error('Card details cooling down'));
    let resolve, reject;
    const promise = new Promise((yes, no) => {resolve = yes; reject = no;});
    pending.set(handle, {promise, resolve, reject}); queue.add(handle);
    if (!queued) {queued = true; queueMicrotask(flush);}
    return promise;
  })).then(results => {
    const parts = results.filter(result => result.status === 'fulfilled').map(result => result.value);
    if (!parts.length && handles.length) throw new Error('Card details unavailable');
    return parts.join('');
  });
})();
(() => {
  'use strict';

  const rootSelector = '.boost-sd__instant-search-container';
  const words = {'Collections':'Kategooriad','Products':'Tooted','Pages':'Lehed','Articles':'Artiklid','Suggestions':'Otsingusoovitused','Popular searches':'Populaarsed otsingud','Popular suggestions':'Populaarsed otsingusoovitused','Recent searches':'Viimased otsingud','Recently viewed products':'Hiljuti vaadatud tooted','Popular products':'Populaarsed tooted','Close':'Sulge','Clear':'Tühjenda','Clear all':'Tühjenda kõik','Powered by':'Toetab','No results found':'Tulemusi ei leitud','View all products':'Vaata kõiki tooteid','View all results':'Vaata kõiki tulemusi','Suggestion list':'Otsingusoovitused','Product list suggestion':'Soovitatud tooted','Clear search term':'Tühjenda otsing','Did you mean':'Kas mõtlesid'};
  function translate(value) {
    value = value.replace(/Did you mean\s*:/gi, 'Kas mõtlesid:').replace(/Sorry,\s*nothing found for/gi, 'Tulemusi ei leitud otsingule');
    const t = value.trim();
    if (words[t]) return value.replace(t, words[t]);
    let match = t.match(/^View all ([\d., ]+) products?$/i);
    if (match) return 'Vaata kõiki tooteid (' + match[1] + ')';
    return value.replace(/^Button: /,'Nupp: ').replace(/View all ([\d., ]+) products?/i,'Vaata kõiki tooteid ($1)').replace(/^Collection: /,'Kategooria: ').replace(/^Title of product is: /,'Toode: ').replace(/^Vendor is: /,'Bränd: ').replace(/^Regular price: /,'Hind: ').replace(/^Sale price: /,'Soodushind: ');
  }

  const details = new Map();
  const pendingDetails = new Set();
  const failedDetails = new Map();
  const detailAttempts = new Map();
  const detailStyles = new Set();
  function cards() {
    const missing = new Set();
    document.querySelectorAll(rootSelector + ' .boost-sd__suggestion-queries-item--product').forEach(item => {
      const link = item.querySelector('a[href*="/products/"]');
      const handle = link?.getAttribute('href').split('/products/')[1]?.split(/[?#]/)[0];
      if (!handle || item.dataset.okPopupCard === handle) return;
      const detail = details.get(handle);
      if (!detail) { if (!pendingDetails.has(handle) && (detailAttempts.get(handle) || 0) < 2 && Date.now() - (failedDetails.get(handle) || 0) > 30000) missing.add(handle); return; }
      const right = item.querySelector('.boost-sd__suggestion-queries-item-product--right');
      if (!right) return;
      const title = item.querySelector('.boost-sd__suggestion-queries-item-title');
      if (title) title.textContent = detail.title;
      right.querySelector('.boost-sd__suggestion-queries-item-price')?.remove();
      const content = detail.content.cloneNode(true);
      const quick = content.querySelector('.ok-quick-add-lite');
      quick?.remove();
      const host = document.createElement('div');
      host.className = 'ok-popup-details';
      host.append(content);
      right.append(host);
      if (quick) item.append(quick);
      const favorite = document.createElement('button');
      favorite.type = 'button';
      favorite.className = 'wishlist-button wishlist-button--card';
      favorite.dataset.wishlistButton = '';
      favorite.dataset.productHandle = handle;
      favorite.setAttribute('aria-label',document.documentElement.lang.startsWith('et')?'Lisa lemmikutesse':'Add to favorites');
      favorite.setAttribute('aria-pressed','false');
      favorite.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 21s-7.5-4.35-9.75-8.55C.53 9.23 1.64 5.25 5.17 4.22 7.44 3.56 9.48 4.32 12 6.8c2.52-2.48 4.56-3.24 6.83-2.58 3.53 1.03 4.64 5.01 2.92 8.23C19.5 16.65 12 21 12 21Z"></path></svg>';
      item.append(favorite);
      if (detail.local) {
        const badge = document.createElement('span');
        badge.style.cssText = 'position:absolute;top:16px;left:16px;z-index:2;color:#087b30;width:20px;height:20px';
        badge.title = document.documentElement.lang.startsWith('et') ? 'Kohalikus laos' : 'Local stock';
        badge.innerHTML = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3.5 10.5 12 3.5l8.5 7M5.5 9.5v10h13v-10M9.5 19.5v-6h5v6" stroke="white" stroke-width="5" stroke-linejoin="round"/><path d="M3.5 10.5 12 3.5l8.5 7M5.5 9.5v10h13v-10M9.5 19.5v-6h5v6" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"/></svg>';
        item.append(badge);
      }
      delete item.dataset.okDetailsError;
      item.dataset.okPopupCard = handle;
    });
    if (!missing.size) return;
    const requestedHandles = Array.from(missing).slice(0,20);
    requestedHandles.forEach(h=>{
      pendingDetails.add(h);
      detailAttempts.set(h, (detailAttempts.get(h) || 0) + 1);
    });
    requestedHandles.forEach(handle => {
    const handles = [handle];
    window.okBoostCardDetails(handles).then(html=>{
      const doc = new DOMParser().parseFromString(html,'text/html');
      doc.querySelectorAll('template[data-ok-card]').forEach(t=>{
        const title = t.content.querySelector('h3')?.textContent || '';
        t.content.querySelector('h3')?.remove();
        t.content.querySelectorAll('style').forEach(s=>{
          if (!detailStyles.has(s.textContent)) { detailStyles.add(s.textContent);document.head.append(s.cloneNode(true)); }
          s.remove();
        });
        details.set(t.dataset.okCard,{title,content:t.content,local:Number(t.dataset.local)>0 && t.dataset.available==='true'});
      });
      schedule();
    }).catch(()=>{
      failedDetails.set(handle, Date.now());
      if (detailAttempts.get(handle) < 2) setTimeout(schedule, 31000);
      document.querySelectorAll(rootSelector+' .boost-sd__suggestion-queries-item--product').forEach(item=>{
        const link=item.querySelector('a[href*="/products/"]');
        const handle=link?.getAttribute('href').split('/products/')[1]?.split(/[?#]/)[0];
        if(!handles.includes(handle))return;
        const price=item.querySelector('.boost-sd__suggestion-queries-item-price');
        if(price && !/[0-9]/.test(price.textContent))price.textContent=document.documentElement.lang.startsWith('et')?'Vaata hinda ja saadavust tootelehelt':'View price and availability on the product page';
        item.dataset.okDetailsError='true';
      });
    }).finally(()=>handles.forEach(h=>pendingDetails.delete(h)));
    });
  }


  const imageSizing = new WeakMap();
  function sharpenImages() {
    document.querySelectorAll(rootSelector + ' .boost-sd__suggestion-queries-item-img').forEach(img => {
      const source = img.getAttribute('src');
      if (!source || imageSizing.get(img)?.source === source) return;
      const state = {source};
      imageSizing.set(img, state);
      img.removeAttribute('data-ok-image-ready');
      const reveal = () => {
        if (imageSizing.get(img) === state && img.isConnected) img.setAttribute('data-ok-image-ready','true');
      };
      let base;
      try { base = new URL(source, location.href); } catch { reveal(); return; }
      if (base.hostname !== 'cdn.shopify.com' && base.origin !== location.origin) { reveal(); return; }
      // Stable slot estimates: never select a tiny image from an intermediate layout.
      img.sizes = '(max-width: 990px) calc((100vw - 40px) / 2), 320px';
      img.srcset = [200,320,480,640,800,1000,1200,1600].map(w => {
        const url = new URL(base);
        url.searchParams.set('width', String(w));
        return url.href + ' ' + w + 'w';
      }).join(', ');
      img.loading = 'eager';
      // Keep the square reserved; reveal only the selected sharp source after decoding.
      img.decode().then(reveal).catch(() => {
        if (img.complete) reveal();
        else {
          img.addEventListener('load',reveal,{once:true});
          img.addEventListener('error',reveal,{once:true});
        }
      });
    });
  }

  function setSuggestionCount() {
    const controller = window.boostISWModule?.instantSearchController;
    if (controller?.searchSettings) controller.searchSettings.suggestionMobileStyle = 'style2';
    if (controller?.defaultData) controller.defaultData.suggestionMobileStyle = 'style2';
    const mobile = document.querySelector('.boost-sd__instant-search-container-mobile');
    const oldWrapper = mobile?.querySelector(':scope > .boost-sd__search-bar-wrapper--mobile');
    if (oldWrapper) {
      const results = oldWrapper.querySelector('.boost-sd__instant-search-results');
      if (results) {
        oldWrapper.querySelector('form.boost-sd__search-bar')?.remove();
        oldWrapper.replaceChildren(results);
        oldWrapper.className = 'boost-sd__search-widget-init-wrapper boost-sd__g-hide';
        results.classList.remove('boost-sd__instant-search-results--mobile-style1');
        results.classList.add('boost-sd__instant-search-results--mobile-style2');
      }
    }

    const integration = window.boostWidgetIntegration;
    const settings = integration?.TAEApp?.config?.templateSettings;
    if (settings?.searchSettings) settings.searchSettings.suggestionMobileStyle = 'style2';
    const blocks = settings?.searchSettings?.suggestionBlocks;
    blocks?.forEach(block => { if (block.type === 'products') block.number = 8; });
    const legacySettings = integration?.app?.[integration.env]?.templateSettings?.searchSettings;
    if (legacySettings) legacySettings.suggestionMobileStyle = 'style2';
    const legacy = legacySettings?.suggestionBlocks;
    legacy?.forEach(block => { if (block.type === 'products') block.number = 8; });
  }
  setSuggestionCount();
  function isSearchInputEvent(event) {
    return Boolean(event.target.matches?.('.ostuklik-header-search__input,.boost-sd__search-bar-input'));
  }
  document.addEventListener('focusin',event=>{if(isSearchInputEvent(event))setSuggestionCount();},true);
  document.addEventListener('input',event=>{if(isSearchInputEvent(event))setSuggestionCount();},true);


  function translateCart() {
    if (!document.documentElement.lang.toLowerCase().startsWith('et')) return;
    document.querySelectorAll('#boost-sd__modal-cart').forEach(cart => {
      cart.setAttribute('aria-label', 'Ostukorv');
      cart.querySelectorAll('.boost-sd__cart-items-count').forEach(el => el.style.setProperty('text-transform','none'));
      const setText = (selector, value) => cart.querySelectorAll(selector).forEach(el => {
        if (el.textContent !== value) el.textContent = value;
      });
      cart.querySelectorAll('.boost-sd__cart-items-count').forEach(el => {
        const count = el.textContent.match(/\((\d+)/);
        if (count) el.textContent = 'Ostukorv (' + count[1] + (Number(count[1]) === 1 ? ' toode)' : ' toodet)');
      });
      setText('.boost-sd__cart-item-empty', 'Sinu ostukorv on tühi');
      setText('.boost-sd__cart-subtotal .boost-sd__cart-label', 'Vahesumma');
      setText('.boost-sd__btn-checkout .boost-sd__button-text', 'Vormista tellimus');
      setText('.boost-sd__btn-view-cart .boost-sd__button-text', 'Vaata ostukorvi');
      cart.querySelectorAll('.boost-sd__btn-checkout').forEach(el => el.setAttribute('aria-label','Vormista tellimus'));
      cart.querySelectorAll('.boost-sd__btn-view-cart').forEach(el => el.setAttribute('aria-label','Vaata ostukorvi'));
      cart.querySelectorAll('.boost-sd__cart-subtotal .boost-sd__cart-price').forEach(el => el.setAttribute('aria-label','Vahesumma: ' + el.textContent.trim()));
      cart.querySelectorAll('.boost-sd__cart-item-remove-btn').forEach(el => el.setAttribute('aria-label','Eemalda ostukorvist'));
      cart.querySelectorAll('.boost-sd__modal-close-btn').forEach(el => el.setAttribute('aria-label','Sulge ostukorv'));
    });
  }

  function cleanCategoryNames() {
    document.querySelectorAll(rootSelector + ' a[href*="/collections/"]').forEach(link => {
      const walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT);
      let text;
      while ((text = walker.nextNode())) {
        const cleaned = text.nodeValue.replace(/^(\s*)\[TEST\]\s*/i, '$1');
        if (cleaned !== text.nodeValue) text.nodeValue = cleaned;
      }
      for (const attribute of ['aria-label', 'title']) {
        const value = link.getAttribute(attribute);
        if (!value) continue;
        const cleaned = value.replace(/(^|:\s*)\[TEST\]\s*/i, '$1');
        if (cleaned !== value) link.setAttribute(attribute, cleaned);
      }
    });
  }

  function productsFirst() {
    document.querySelectorAll(rootSelector + ' .boost-sd__instant-search-product-list').forEach(products => {
      const parent = products.parentElement;
      const suggestions = Array.from(parent.children).find(child => child.matches('.boost-sd__suggestion-queries-group'));
      if (suggestions && products.compareDocumentPosition(suggestions) & Node.DOCUMENT_POSITION_PRECEDING) parent.insertBefore(products, suggestions);
    });
    document.querySelectorAll(rootSelector + ' .boost-sd__instant-search-autocomplete').forEach(layout => {
      const products = layout.querySelector(':scope > .boost-sd__instant-search-column--products');
      const others = layout.querySelector(':scope > .boost-sd__instant-search-column--others');
      if (!products || !others) return;
      if (products.style.order !== '0') products.style.setProperty('order', '0', 'important');
      if (others.style.order !== '1') others.style.setProperty('order', '1', 'important');
      if (products.compareDocumentPosition(others) & Node.DOCUMENT_POSITION_PRECEDING) layout.insertBefore(products, others);
    });
  }


  let mobileColumns = 2;
  function mobileViewControls() {
    document.querySelectorAll('.boost-sd-container-search-page').forEach(root => {
      if (root.style.getPropertyValue('--ok-mobile-columns') !== String(mobileColumns)) root.style.setProperty('--ok-mobile-columns',String(mobileColumns));
      const toolbar = root.querySelector('.boost-sd__toolbar');
      if (!toolbar || toolbar.querySelector('.ok-mobile-columns')) return;
      const group = document.createElement('div');
      group.className = 'ok-mobile-columns';
      group.setAttribute('role','group');
      const et = document.documentElement.lang.startsWith('et');
      group.setAttribute('aria-label',et?'Tooteid reas':'Products per row');
      [1,2].forEach(n=>{
        const button = document.createElement('button');
        button.type='button';
        button.innerHTML = n === 1
          ? '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="currentColor"><rect x="4" y="3" width="16" height="8" rx="1"/><rect x="4" y="13" width="16" height="8" rx="1"/></svg>'
          : '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true" fill="currentColor"><rect x="3" y="3" width="8" height="8" rx="1"/><rect x="13" y="3" width="8" height="8" rx="1"/><rect x="3" y="13" width="8" height="8" rx="1"/><rect x="13" y="13" width="8" height="8" rx="1"/></svg>';
        button.dataset.okMobileColumns=String(n);
        button.setAttribute('aria-label',et?(n===1?'1 toode reas':'2 toodet reas'):n+' products per row');
        button.setAttribute('aria-pressed',String(n===mobileColumns));
        group.append(button);
      });
      toolbar.append(group);
    });
  }
  document.addEventListener('click',event=>{
    const button=event.target.closest?.('[data-ok-mobile-columns]');
    if(!button)return;
    mobileColumns=Number(button.dataset.okMobileColumns);
    document.querySelectorAll('.boost-sd-container-search-page').forEach(root=>{
      root.style.setProperty('--ok-mobile-columns',String(mobileColumns));
      root.querySelectorAll('[data-ok-mobile-columns]').forEach(b=>b.setAttribute('aria-pressed',String(Number(b.dataset.okMobileColumns)===mobileColumns)));
    });
  });

  function positionPopup() {
    const input = document.querySelector('.ostuklik-header-search__input');
    if (!input) return;
    const openPopup = Array.from(document.querySelectorAll('.boost-sd__search-widget-init-wrapper')).some(popup=>{
      const owner = popup.getAttribute('aria-controls');
      return !popup.classList.contains('boost-sd__g-hide') && !popup.hidden && (!owner || owner === input.id);
    });
    if (!openPopup) return;
    const rect = input.getBoundingClientRect();
    if (!rect.width) return;
    const mobile = window.innerWidth < 991;
    const viewport = window.visualViewport;
    const values = {
      '--ok-popup-top': rect.bottom + 'px',
      '--ok-popup-left': (mobile ? (viewport?.offsetLeft || 0) : rect.left) + 'px',
      '--ok-popup-width': (mobile ? (viewport?.width || window.innerWidth) : rect.width) + 'px',
      '--ok-popup-height': Math.max(0,(viewport ? viewport.offsetTop + viewport.height : window.innerHeight)-rect.bottom) + 'px'
    };
    for (const [key,value] of Object.entries(values)) {
      if (document.documentElement.style.getPropertyValue(key) !== value) document.documentElement.style.setProperty(key,value);
    }
    document.querySelectorAll('.boost-sd__search-widget-init-wrapper').forEach(popup => {
      const owner = popup.getAttribute('aria-controls');
      if (owner && owner !== input.id) { popup.classList.remove('ok-header-popup'); return; }
      popup.classList.add('ok-header-popup');
      const atPageTop = (document.scrollingElement?.scrollTop || 0) <= 1;
      const resultsAtTop = Array.from(popup.querySelectorAll('.boost-sd__instant-search-results,.boost-sd__instant-search-product-list')).every(el => el.scrollTop <= 1);
      popup.classList.toggle('ok-pull-refresh', mobile && atPageTop && popup.scrollTop <= 1 && resultsAtTop);

      // Geometry belongs to CSS; Boost's deferred inline writes cannot move this popup.
      for (const key of ['position','top','left','right','width','max-width','height','max-height']) {
        if (popup.style.getPropertyPriority(key) === 'important') popup.style.removeProperty(key);
      }
      if (mobile && !input.value.trim() && !popup.querySelector('.boost-sd__suggestion-queries-item--recent')) {
        popup.style.setProperty('display','none','important');
        popup.dataset.okEmptyHidden = 'true';
        const controller = window.boostISWModule?.instantSearchController;
        if (controller?.getState?.().isOpen) controller.closeSuggestion();
        input.setAttribute('aria-expanded','false');
      } else if (popup.dataset.okEmptyHidden) {
        popup.style.removeProperty('display');
        delete popup.dataset.okEmptyHidden;
      }
    });
  }

  function update() {
    positionPopup();
    mobileViewControls();
    translateCart();
    setSuggestionCount();
    productsFirst();
    cards();
    sharpenImages();
    cleanCategoryNames();
    if (!document.documentElement.lang.toLowerCase().startsWith('et')) return;
    document.querySelectorAll(rootSelector).forEach(root => {
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement.closest('script,style,.boost-sd__suggestion-queries-item-title')) continue;
        const value = translate(node.nodeValue);
        if (value !== node.nodeValue) node.nodeValue = value;
      }
      root.querySelectorAll('[aria-label]').forEach(el => {
        const value = translate(el.getAttribute('aria-label'));
        if (value !== el.getAttribute('aria-label')) el.setAttribute('aria-label',value);
      });
      root.querySelectorAll('.boost-sd__search-bar-input').forEach(el => el.setAttribute('aria-label','Otsi tooteid'));
    });
  }
  let pending = false;
  const watchedRoots = rootSelector;
  const observer = new MutationObserver(records => {
    if (records.some(r => (r.target.nodeType === 1 ? r.target : r.target.parentElement)?.closest?.(watchedRoots) || Array.from(r.addedNodes).some(n => n.nodeType === 1 && (n.matches?.(watchedRoots) || n.querySelector?.(watchedRoots))))) {
      if (records.every(record => record.type === 'attributes')) {
        scheduleVisiblePopup();
        return;
      }
      schedule();
    }
  });
  function observeSearchChanges() {
    observer.observe(document.body,{childList:true,subtree:true});
    document.querySelectorAll(rootSelector).forEach(root => {
      observer.observe(root,{childList:true,characterData:true,subtree:true,attributes:true,attributeFilter:['style','aria-controls']});
    });
    document.querySelectorAll('.boost-sd__search-widget-init-wrapper').forEach(wrapper => {
      observer.observe(wrapper,{attributes:true,attributeFilter:['style','aria-controls']});
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => {
      pending = false;
      observer.disconnect();
      try { update(); } finally { observeSearchChanges(); }
    });
  }
  let positionPending = false;
  function scheduleVisiblePopup() {
    if (positionPending) return;
    const input = document.querySelector('.ostuklik-header-search__input');
    if (!input?.value.trim()) return;
    const visiblePopup = Array.from(document.querySelectorAll('.boost-sd__search-widget-init-wrapper.ok-header-popup')).some(popup => {
      const owner = popup.getAttribute('aria-controls');
      return (!owner || owner === input?.id) && !popup.classList.contains('boost-sd__g-hide') && !popup.hidden;
    });
    if (positionPending || !input?.value.trim() || (input.getAttribute('aria-expanded') !== 'true' && !visiblePopup)) return;
    positionPending = true;
    requestAnimationFrame(()=>{
      positionPending = false;
      observer.disconnect();
      try { positionPopup(); } finally {
        observeSearchChanges();
      }
    });
  }
  let viewportSettleTimer;
  function settlePopupViewport() {
    scheduleVisiblePopup();
    clearTimeout(viewportSettleTimer);
    viewportSettleTimer = setTimeout(scheduleVisiblePopup, 250);
  }
  window.visualViewport?.addEventListener('resize',settlePopupViewport,{passive:true});
  document.addEventListener('focusout',event=>{
    if(event.target.matches?.('.ostuklik-header-search__input')) settlePopupViewport();
  },true);
  window.visualViewport?.addEventListener('scroll',scheduleVisiblePopup,{passive:true});
  window.addEventListener('resize',settlePopupViewport,{passive:true});
  window.addEventListener('scroll',scheduleVisiblePopup,{passive:true,capture:true});
  document.addEventListener('ok:boost-ui-ready',mobileViewControls);
  function closeSearchForHeaderControl(event) {
    const control = event.target.closest?.('a,button,summary');
    if (!control?.closest('#header-component') || control.closest('.ostuklik-header-search,form[role="search"],.boost-sd__instant-search-container')) return;
    if (control.matches('[type="submit"]')) return;
    const controller = window.boostISWModule?.instantSearchController;
    controller?.closeSuggestion?.();
    document.querySelectorAll('.ok-header-popup').forEach(popup=>{
      popup.classList.add('boost-sd__g-hide');
      popup.removeAttribute('aria-controls');
    });
    document.querySelector('.ostuklik-header-search__input')?.setAttribute('aria-expanded','false');
  }
  document.addEventListener('pointerdown',closeSearchForHeaderControl,true);
  document.addEventListener('click',closeSearchForHeaderControl,true);
  document.addEventListener('input',event=>{if(isSearchInputEvent(event))schedule();},true);
  document.addEventListener('search',event=>{if(isSearchInputEvent(event))schedule();},true);
  document.addEventListener('focusin',event=>{if(isSearchInputEvent(event))schedule();},true);
  if (document.body) schedule();
  else document.addEventListener('DOMContentLoaded',schedule,{once:true});
})();


(() => {
  const stateKey = 'ostuklikkSearchReturn';
  const popupSelector = '.boost-sd__search-widget-init-wrapper';
  const inputSelector = '.ostuklik-header-search__input';
  const scrollSelectors = ['.boost-sd__instant-search-results', '.boost-sd__instant-search-product-list', '.boost-sd__g-scrollable'];
  let restoring = false;

  function pageKey() {
    const url = new URL(location.href);
    url.searchParams.delete('preview_theme_id');
    url.searchParams.sort();
    return url.pathname + url.search;
  }

  function visiblePopup() {
    return Array.from(document.querySelectorAll(popupSelector)).find(popup =>
      !popup.hidden && !popup.classList.contains('boost-sd__g-hide') && popup.getClientRects().length);
  }

  function capturePreview(popup, saved) {
    sessionStorage.removeItem('ostuklikkSearchPreview');
    const startedAt = performance.now();
    const styleClasses = new Map();
    const styleRules = [];
    let copiedNodes = 0;
    let styleCharacters = 0;
    const snapshotLimit = new Error('Search preview budget exceeded');
    const properties = ('display position box-sizing width height min-width min-height max-width max-height margin-top margin-right margin-bottom margin-left padding-top padding-right padding-bottom padding-left border-top border-right border-bottom border-left border-radius background-color background-image background-size background-position background-repeat color font-family font-size font-weight font-style line-height letter-spacing text-align text-decoration text-transform white-space word-break overflow-wrap vertical-align opacity visibility overflow-x overflow-y flex-direction flex-wrap flex-grow flex-shrink flex-basis align-items align-self align-content justify-content gap row-gap column-gap list-style-type list-style-position grid-template-areas grid-area grid-template-columns grid-template-rows grid-auto-flow grid-column grid-row order object-fit object-position aspect-ratio box-shadow fill stroke stroke-width top right bottom left z-index transform transform-origin').split(' ');
    const scrollLookup = new Map(saved.scrolls.map(item => [popup.querySelectorAll(item.selector)[item.index], item]));
    function copy(source) {
      if (++copiedNodes > 2500 || performance.now() - startedAt > 120) throw snapshotLimit;
      if (source.nodeType === Node.TEXT_NODE) return document.createTextNode(source.textContent);
      if (source.nodeType !== Node.ELEMENT_NODE || source.matches('script,style,link,iframe,template')) return null;
      const computed = getComputedStyle(source);
      if (computed.display === 'none') return null;
      const svg = source.namespaceURI === 'http://www.w3.org/2000/svg';
      const target = svg ? document.createElementNS(source.namespaceURI, source.localName) : document.createElement(source.localName.includes('-') ? 'div' : source.localName);
      for (const name of ['href','src','alt','title','viewBox','d','fill','stroke','stroke-width','stroke-linecap','stroke-linejoin','cx','cy','r','x','y','x1','y1','x2','y2','points','xmlns','type','aria-label']) {
        if (source.hasAttribute(name)) target.setAttribute(name, source.getAttribute(name));
      }
      if (source.matches('a')) {
        try { if (new URL(source.href, location.href).origin !== location.origin) target.removeAttribute('href'); } catch { target.removeAttribute('href'); }
      }
      const declarations = properties.map(property => `${property}:${computed.getPropertyValue(property)}`).join(';');
      let className = styleClasses.get(declarations);
      if (!className) {
        className = `ok-preview-${styleClasses.size}`;
        styleClasses.set(declarations, className);
        const rule = `.${className}{${declarations}}`;
        styleCharacters += rule.length;
        if (styleCharacters > 400000) throw snapshotLimit;
        styleRules.push(rule);
      }
      target.setAttribute('class', className);
      if (source.matches('input')) { target.value = source.value; target.setAttribute('value', source.value); target.setAttribute('readonly', ''); }
      if (source.matches('img')) {
        target.src = source.currentSrc || source.src;
        const rect = source.getBoundingClientRect();
        target.loading = rect.bottom > 0 && rect.top < innerHeight ? 'eager' : 'lazy';
      }
      if (source.scrollTop) target.dataset.okScrollTop = source.scrollTop;
      const scrollItem = scrollLookup.get(source);
      if (scrollItem) {
        target.dataset.okReturnSelector = scrollItem.selector;
        target.dataset.okReturnIndex = scrollItem.index;
      }
      if (source.matches('button')) target.setAttribute('disabled', '');
      for (const child of source.childNodes) {
        if (child.nodeType === 1 && child.matches(popupSelector)) continue;
        const clone = copy(child);
        if (clone) target.append(clone);
      }
      return target;
    }
    const canvas = document.createElement('div');
    canvas.style.cssText = 'position:relative;width:' + innerWidth + 'px;height:' + innerHeight + 'px;pointer-events:none';
    const header = document.querySelector('.ostuklik-header-search__input')?.closest('form');
    for (const source of [header, popup].filter(Boolean)) {
      const clone = copy(source);
      if (!clone) continue;
      const rect = source.getBoundingClientRect();
      Object.assign(clone.style, {position:'absolute',top:rect.top+'px',left:rect.left+'px',right:'auto',bottom:'auto',width:rect.width+'px',height:rect.height+'px',boxSizing:'border-box',margin:'0',transform:'none',pointerEvents:source === popup ? 'auto' : 'none'});
      if (source === popup) clone.dataset.okReturnPopup = '';
      canvas.append(clone);
    }
    const html = canvas.outerHTML;
    const stylesheet = document.createElement('style');
    stylesheet.textContent = styleRules.join('\n');
    const previewHtml = html + stylesheet.outerHTML;
    if (previewHtml.length < 600000) sessionStorage.setItem('ostuklikkSearchPreview', JSON.stringify({url:saved.url,savedAt:saved.savedAt,width:innerWidth,html:previewHtml}));
  }

  document.addEventListener('click', event => {
    if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest?.('a[href]');
    const popup = link?.closest(popupSelector);
    const input = document.querySelector(inputSelector);
    if (!popup || popup !== visiblePopup() || !input?.value.trim() || link.target === '_blank' || link.hasAttribute('download')) return;
    const url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/products\//.test(url.pathname)) return;
    const scrolls = scrollSelectors.flatMap(selector =>
      Array.from(popup.querySelectorAll(selector)).map((el, index) => ({ selector, index, top: el.scrollTop })));
    try {
      const products = Array.from(popup.querySelectorAll('a[href*="/products/"]')).map(link => link.getAttribute('href'));
      const saved = { url: pageKey(), query: input.value, products, popupIndex: Array.from(document.querySelectorAll(popupSelector)).indexOf(popup), top: popup.scrollTop, scrolls, savedAt: Date.now() };
      history.replaceState({ ...history.state, [stateKey]: saved }, '');
      sessionStorage.setItem(stateKey, JSON.stringify(saved));
      capturePreview(popup, saved);
    } catch {}
  }, true);

  async function waitForRestoredPopup(isCancelled) {
    let previous = '', stable = 0;
    for (let attempt = 0; attempt < 80; attempt++) {
      if (isCancelled()) return false;
      const popup = visiblePopup();
      const cards = popup ? Array.from(popup.querySelectorAll('.boost-sd__suggestion-queries-item--product')) : [];
      const images = popup ? Array.from(popup.querySelectorAll('.boost-sd__suggestion-queries-item-img')) : [];
      const ready = cards.length > 0 && cards.every(card => card.dataset.okPopupCard || card.dataset.okDetailsError) &&
        images.every(img => img.complete && img.dataset.okImageReady === 'true') && document.fonts?.status !== 'loading';
      const signature = ready ? popup.innerText + '|' + popup.getBoundingClientRect().height + '|' + popup.scrollHeight : '';
      stable = signature && signature === previous ? stable + 1 : 0;
      previous = signature;
      if (stable >= 3) return true;
      await new Promise(resolve => setTimeout(resolve, 50));
    }
    return !isCancelled();
  }

  async function restoreSearch() {
    let saved = history.state?.[stateKey];
    try { if (!saved || saved.url !== pageKey()) saved = JSON.parse(sessionStorage.getItem(stateKey) || 'null'); } catch {}
    if (restoring || !saved || saved.url !== pageKey() || Date.now() - saved.savedAt > 1800000) return;
    restoring = true;
    document.documentElement.dataset.okSearchReturnStage = 'starting';
    const initialInput = document.querySelector(inputSelector);
    const retainedPopup = Array.from(document.querySelectorAll(popupSelector)).find((popup, index) => {
      if (index !== saved.popupIndex) return false;
      const products = Array.from(popup.querySelectorAll('a[href*="/products/"]')).map(link => link.getAttribute('href'));
      return saved.products?.length && products.length === saved.products.length && products.every((href, index) => href === saved.products[index]);
    });
    if (initialInput) {
      initialInput.value = saved.query;

    }
    if (initialInput && retainedPopup) {
      retainedPopup.hidden = false;
      retainedPopup.classList.remove('boost-sd__g-hide');
      retainedPopup.setAttribute('aria-controls', initialInput.id);
      initialInput.setAttribute('aria-expanded', 'true');
      retainedPopup.scrollTop = saved.top;
      for (const item of saved.scrolls) {
        const el = retainedPopup.querySelectorAll(item.selector)[item.index];
        if (el) el.scrollTop = item.top;
      }
    }
    let cancelled = false;
    const cancel = event => {
      if (!event.composedPath().some(node => node.id === 'ok-search-return-preview')) {
        cancelled = true;
        window.okSearchReturnPreview?.finish();
      }
    };
    document.addEventListener('pointerdown', cancel, { once: true });
    document.addEventListener('keydown', cancel, { once: true });
    try {
      let controller, input;
      let initializationRequested = false;
      for (let attempt = 0; attempt < 100; attempt++) {
        controller = window.boostISWModule?.instantSearchController;
        input = document.querySelector(inputSelector);
        if (controller && !controller.searchSettings && !initializationRequested) {
          initializationRequested = true;
          document.dispatchEvent(new MouseEvent('mousemove', {bubbles:true}));
        }
        if (controller?.openSuggestion && controller?.searchAndRender && controller.searchSettings && document.querySelector(popupSelector) && input) break;
        if (cancelled) return;
        await new Promise(resolve => setTimeout(resolve, 100));
      }
      if (cancelled || !controller?.openSuggestion || !controller.searchSettings || !input) return;
      document.documentElement.dataset.okSearchReturnStage = 'controller-ready';
      await controller.whenReady();
      if (cancelled) return;
      input.value = saved.query;
      controller.syncAllInputs(saved.query);
      await controller.openSuggestion(input);
      if (!retainedPopup?.isConnected) await controller.searchAndRender(saved.query);
      if (cancelled) return;
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      const popup = visiblePopup();
      if (!popup) return;
      if (!await waitForRestoredPopup(() => cancelled)) return;
      const applyScroll = () => {
        const currentPopup = visiblePopup();
        if (!currentPopup) return;
        currentPopup.scrollTop = saved.top;
        for (const item of (window.okSearchReturnPreview?.scrolls() || saved.scrolls)) {
          const el = currentPopup.querySelectorAll(item.selector)[item.index];
          if (el) el.scrollTop = item.top;
        }
      };
      const resumedScrolls = window.okSearchReturnPreview?.scrolls();
      if (resumedScrolls) saved.scrolls = resumedScrolls;
      applyScroll();
      document.documentElement.dataset.okSearchReturnStage = 'ready';
      window.okSearchReturnPreview?.finish();
      const scrollObserver = new MutationObserver(applyScroll);
      scrollObserver.observe(document.body, { childList: true, subtree: true });
      const stopScrollRestore = () => {
        scrollObserver.disconnect();
        for (const name of ['wheel','touchstart','pointerdown','keydown']) document.removeEventListener(name, stopScrollRestore, true);
      };
      for (const name of ['wheel','touchstart','pointerdown','keydown']) document.addEventListener(name, stopScrollRestore, { capture: true, passive: true });
      setTimeout(stopScrollRestore, 2500);
      const next = { ...history.state };
      delete next[stateKey];
      history.replaceState(next, '');
      try { sessionStorage.removeItem(stateKey); } catch {}
      document.dispatchEvent(new CustomEvent('ok:boost-ui-ready'));
    } finally {
      restoring = false;
      document.removeEventListener('pointerdown', cancel);
      document.removeEventListener('keydown', cancel);
    }
  }

  window.addEventListener('pagereveal', () => {
    if (history.state?.[stateKey] || performance.getEntriesByType('navigation')[0]?.type === 'back_forward') restoreSearch().catch(() => {});
  });
  window.addEventListener('pageshow', event => {
    if (event.persisted || performance.getEntriesByType('navigation')[0]?.type === 'back_forward') restoreSearch().catch(() => {});
  });
  if (performance.getEntriesByType('navigation')[0]?.type === 'back_forward') {
    restoreSearch().catch(() => {});
  }
})();

(() => {
  const cartUrl = () => (window.Shopify?.routes?.root || '/').replace(/\/$/,'') + '/cart';
  window.addEventListener('click',event=>{
    const link=event.target.closest?.('a.header-actions__cart-action');
    if(!link)return;
    event.stopImmediatePropagation();
    link.href=cartUrl();
  },true);
  window.addEventListener('keydown',event=>{
    const link=event.target.closest?.('a.header-actions__cart-action');
    if(!link || !['Enter',' '].includes(event.key))return;
    event.preventDefault();
    event.stopImmediatePropagation();
    window.location.assign(cartUrl());
  },true);
  window.addEventListener('boost-sd-open-cart',event=>{
    event.stopImmediatePropagation();
    window.location.assign(cartUrl());
  },true);
})();

(() => {
  let gesture = null;
  let refreshing = false;
  const threshold = 128;
  function reset() {
    gesture?.indicator.remove();
    gesture = null;
  }
  document.addEventListener('touchstart', event => {
    reset();
    if (refreshing || window.innerWidth >= 991 || event.touches.length !== 1) return;
    const popup = event.target.closest?.('.ok-header-popup');
    if (!popup || popup.classList.contains('boost-sd__g-hide')) return;
    if (event.target.closest('input,textarea,select,button')) return;
    for (let el = event.target; el && popup.contains(el); el = el.parentElement) {
      if (el.scrollTop > 1) return;
      if (el === popup) break;
    }
    const indicator = document.createElement('div');
    indicator.className = 'ok-popup-refresh-status';
    indicator.setAttribute('role','status');
    indicator.hidden = true;
    popup.appendChild(indicator);
    const touch = event.touches[0];
    gesture = {x:touch.clientX,y:touch.clientY,popup,indicator,armed:false};
  }, {passive:true});
  document.addEventListener('touchmove', event => {
    if (!gesture) return;
    if (event.touches.length !== 1 || gesture.popup.scrollTop > 1) { reset(); return; }
    const touch = event.touches[0];
    const dy = touch.clientY - gesture.y;
    if (dy < -8 || Math.abs(touch.clientX-gesture.x) > 60) { reset(); return; }
    gesture.armed = dy >= threshold;
    gesture.indicator.hidden = dy < 20;
    gesture.indicator.textContent = gesture.armed ? 'Vabasta värskendamiseks' : 'Tõmba alla, et värskendada';
  }, {passive:true});
  document.addEventListener('touchend', async () => {
    if (!gesture) return;
    if (!gesture.armed) { reset(); return; }
    const input = document.querySelector('.ostuklik-header-search__input');
    const query = input?.value.trim();
    const controller = window.boostISWModule?.instantSearchController;
    if (!query || typeof controller?.searchAndRender !== 'function') { reset(); return; }
    refreshing = true;
    gesture.indicator.textContent = 'Värskendan…';
    try {
      await controller.searchAndRender(query);
    } finally {
      refreshing = false;
      reset();
    }
  }, {passive:true});
  document.addEventListener('touchcancel',reset,{passive:true});
})();


(() => {
  const inputSelector = '.ostuklik-header-search__input,.boost-sd__search-bar-input';
  const resultsSelector = '.boost-sd__search-widget-init-wrapper,.boost-sd-container-search-page,.ok-predictive-search';
  let gesture = null;

  document.addEventListener('touchstart', event => {
    gesture = null;
    const input = document.activeElement;
    if (event.touches.length !== 1 || !input?.matches(inputSelector)) return;
    if (!event.target.closest?.(resultsSelector) || event.target.closest('input,textarea,select')) return;
    gesture = { input, x: event.touches[0].clientX, y: event.touches[0].clientY };
  }, { passive: true, capture: true });

  document.addEventListener('touchmove', event => {
    if (!gesture || event.touches.length !== 1) return;
    const dx = Math.abs(event.touches[0].clientX - gesture.x);
    const dy = Math.abs(event.touches[0].clientY - gesture.y);
    if (dy < 12 || dy <= dx) return;
    const input = gesture.input;
    gesture = null;
    if (document.activeElement === input) input.blur();
  }, { passive: true, capture: true });

  const clearGesture = () => { gesture = null; };
  document.addEventListener('touchend', clearGesture, { passive: true });
  document.addEventListener('touchcancel', clearGesture, { passive: true });
})();

(() => {
  const style = document.createElement("style");
  style.textContent = "\n\n.boost-sd__search-widget-init-wrapper.ok-header-popup:has(.boost-sd__instant-search-no-product) {\n  position: fixed !important;\n  top: var(--ok-popup-top) !important;\n  left: var(--ok-popup-left) !important;\n  right: auto !important;\n  width: var(--ok-popup-width) !important;\n  max-width: var(--ok-popup-width) !important;\n  box-sizing: border-box !important;\n  margin: 0 !important;\n  background: #fff !important;\n}\n.boost-sd__search-widget-init-wrapper.ok-header-popup:has(.boost-sd__instant-search-no-product) :is(.boost-sd__instant-search-results,.boost-sd__instant-search-autocomplete,.boost-sd__instant-search-column,.boost-sd__suggestion-queries-group) {\n  width: 100% !important;\n  max-width: 100% !important;\n  min-width: 0 !important;\n  box-sizing: border-box !important;\n}\n.boost-sd__search-widget-init-wrapper.ok-header-popup .boost-sd__instant-search-no-product > .boost-sd__instant-search-column {\n  flex: 1 1 100% !important;\n}\n";
  document.head.append(style);
  const update = () => {
    const input = document.querySelector('.ostuklik-header-search__input');
    if (!input) return;
    const rect = input.getBoundingClientRect();
    const mobile = innerWidth < 991;
    document.querySelectorAll('.boost-sd__search-widget-init-wrapper:has(.boost-sd__instant-search-no-product)').forEach(popup => {
      if (popup.hidden || popup.classList.contains('boost-sd__g-hide')) return;
      const values = {'--ok-popup-top':rect.bottom+'px','--ok-popup-left':(mobile ? (visualViewport?.offsetLeft || 0) : rect.left)+'px','--ok-popup-width':(mobile ? (visualViewport?.width || innerWidth) : rect.width)+'px'};
      for (const [key,value] of Object.entries(values)) if (popup.style.getPropertyValue(key) !== value) popup.style.setProperty(key,value);
      if (!popup.classList.contains('ok-header-popup')) popup.classList.add('ok-header-popup');
    });
  };
  let pending = false;
  const schedule = () => {
    if (pending) return;
    pending = true;
    requestAnimationFrame(() => { pending = false; update(); });
  };
  new MutationObserver(records => {
    if (records.some(r => r.target.closest?.('.boost-sd__search-widget-init-wrapper') || Array.from(r.addedNodes).some(n => n.nodeType === 1 && (n.matches('.boost-sd__search-widget-init-wrapper') || n.querySelector('.boost-sd__search-widget-init-wrapper'))))) schedule();
  }).observe(document.body,{childList:true,subtree:true,attributes:true,attributeFilter:['class','style']});
  document.addEventListener('focusin',schedule);
  window.addEventListener('resize',schedule);
  window.visualViewport?.addEventListener('resize',schedule);
  schedule();
})();

(() => {
 const style = document.createElement("style");
 style.textContent = ".boost-sd-container-search-page .boost-sd__toolbar > .ok-boost-local-first {justify-self:start!important;justify-content:flex-start!important;text-align:left!important;margin-left:0!important;margin-right:auto!important;}\n@media(max-width:767px){\n.boost-sd-container-search-page .boost-sd__toolbar:has(.ok-boost-local-first){width:calc(100vw - 8px)!important;max-width:none!important;margin-left:calc((100% - 100vw + 8px)/2)!important;margin-right:0!important;box-sizing:border-box!important;}\n.boost-sd-container-search-page .boost-sd__toolbar > .ok-boost-local-first{padding-left:6px!important;}}\n";
 document.head.append(style);
})();

(() => {
 const style = document.createElement("style");
 style.id = "ok-compact-search-toolbar";
 style.textContent = "@media(max-width:767px){\n.boost-sd-container-search-page :is(.boost-sd__search-result-toolbar-container,.boost-sd__toolbar-container,.boost-sd__toolbar-inner,.boost-sd__toolbar-content){margin-top:0!important;margin-bottom:0!important;padding-top:0!important;padding-bottom:0!important;min-height:0!important;}\n.boost-sd-container-search-page .boost-sd__search-result-toolbar{padding:2px 0!important;margin:0!important;min-height:0!important;}\n.boost-sd-container-search-page .boost-sd__search-result-toolbar-panel{padding:4px 0!important;line-height:20px!important;font-size:14px!important;}\n.boost-sd-container-search-page .boost-sd__toolbar:has(.ok-boost-local-first){row-gap:2px!important;padding-top:2px!important;padding-bottom:0!important;}\n.boost-sd-container-search-page .boost-sd__toolbar > .ok-boost-local-first{height:40px!important;min-height:40px!important;font-size:13px!important;padding-top:0!important;padding-bottom:0!important;}\n.boost-sd-container-search-page .ok-mobile-columns button{min-height:40px!important;height:40px!important;}\n.boost-sd-container-search-page .boost-sd__toolbar:has(.ok-boost-local-first) .boost-sd__toolbar-top-mobile{grid-template-columns:minmax(0,2fr) minmax(0,1fr)!important;margin:0!important;padding:0!important;}\n.boost-sd-container-search-page .boost-sd__toolbar:has(.ok-boost-local-first) .boost-sd__sorting-button{flex-direction:row!important;justify-content:flex-start!important;align-items:center!important;gap:4px!important;min-height:44px!important;height:44px!important;padding:6px 24px 6px 6px!important;font-size:13px!important;line-height:18px!important;white-space:nowrap!important;}\n.boost-sd-container-search-page .boost-sd__toolbar:has(.ok-boost-local-first) .boost-sd__sorting-value{display:block!important;width:auto!important;min-width:0!important;white-space:nowrap!important;overflow:hidden!important;text-overflow:ellipsis!important;text-align:left!important;}\n.boost-sd-container-search-page .boost-sd__toolbar:has(.ok-boost-local-first) .boost-sd__filter-tree-toggle-button{min-height:44px!important;height:44px!important;padding:6px!important;font-size:13px!important;gap:8px!important;}\n.boost-sd-container-search-page .boost-sd__toolbar:has(.ok-boost-local-first) .boost-sd__filter-tree-toggle-button-icon{width:20px!important;height:20px!important;flex:0 0 20px!important;}\n}";
 document.head.append(style);
})();

(() => {
 const style = document.createElement("style");
 style.id = "ok-search-toolbar-row-height";
 style.textContent = "@media(max-width:767px){\n.boost-sd-container-search-page .boost-sd__toolbar:has(.ok-boost-local-first){grid-template-rows:40px 40px!important;align-items:start!important;align-content:start!important;row-gap:2px!important;margin-bottom:0!important;padding-bottom:0!important;}\n.boost-sd-container-search-page .boost-sd__toolbar:has(.ok-boost-local-first) :is(.boost-sd__toolbar-item--sorting,.boost-sd__toolbar-top-mobile,.boost-sd__sorting){box-sizing:border-box!important;height:40px!important;min-height:0!important;margin-top:0!important;margin-bottom:0!important;padding-top:0!important;padding-bottom:0!important;align-self:start!important;}\n.boost-sd-container-search-page .boost-sd__toolbar:has(.ok-boost-local-first) .boost-sd__toolbar-top-mobile{align-items:start!important;grid-template-rows:40px!important;}\n.boost-sd-container-search-page .boost-sd__toolbar:has(.ok-boost-local-first) :is(.boost-sd__sorting-button,.boost-sd__filter-tree-toggle-button){box-sizing:border-box!important;height:40px!important;min-height:40px!important;max-height:40px!important;margin:0!important;padding-top:0!important;padding-bottom:0!important;display:flex!important;align-items:center!important;line-height:18px!important;}\n.boost-sd-container-search-page :is(.boost-sd__toolbar-container,.boost-sd__toolbar-inner,.boost-sd__toolbar-content){margin-bottom:0!important;padding-bottom:0!important;min-height:0!important;}\n.boost-sd-container-search-page .boost-sd__product-list{margin-top:0!important;}\n}";
 document.head.append(style);
})();


